import { reduxStateDomains } from '../redux.constants';
import { LocationWithQuery } from './location.models';

const getLocation = globalState => globalState[reduxStateDomains.ROUTER_STATE].location as LocationWithQuery;

export const locationSelectors = { getLocation };
